<template>

        <transition name="slide-down">
            <div class="title-wrapper" v-show="menushow">

                <div class="left">
                    <span class="iconfont icon-back"></span>
                </div>
                <div class="right">
<!--                    <div class="icon-wrapper">-->
<!--                        <span class="iconfont icon-cart"></span>-->
<!--                        <span class="iconfont icon-Person"></span>-->
<!--                        <span class="iconfont icon-more"></span>-->
<!--                    </div>-->
                </div>
            </div>
        </transition>


</template>

<script>

    export default {
        props:["menushow"],
        name: "ebooktitle",
        data() {
            return {

            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            // backbefore(){
            //     // alert(1)
            //     //   SmartCity.goBack();
            //     this.$emit('callback', 'left')
            // },
            // share(){
            //     this.$emit('callback', 'right')
            //     // SmartCity.shareTo(this.ztopData.sharedata);
            // }
        },
    }
</script>

<style scoped lang="scss">
    @import '../assets/styles/global.scss';
    .title-wrapper{
        position: absolute;

        left:0;
        display: flex;
        width: 100%;
        height: px2rem(48);
        z-index: 101;
        background: white;
        box-shadow: 0 px2rem(8) px2rem(8) rgba(0,0,0,.15) ;


    .left{
        flex: 0 0 px2rem(30);
    @include center;
        /*@import '../assets/styles/global.scss';*/
        //@include center;
        font-size:px2rem(22) ;
    }
    .right{
        flex: 1;
        display: flex;
        justify-content: flex-end;
    .icon-wrapper{
        flex: 0 0 px2rem(40);
        /*@import '../assets/styles/global.scss';*/
        @include center;

    span{
        padding: 0 px2rem(10);
    }
    }
    }

    }
</style>


// WEBPACK FOOTER //
// src/components/ebooktitle.vue